import { __ } from "../utils";
/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */

var Widget = function Widget() {
  return /*#__PURE__*/React.createElement("div", {
    className: "react-boilerplate-widget"
  }, /*#__PURE__*/React.createElement("h3", null, __("Hello, World!")), /*#__PURE__*/React.createElement("p", null, __("I got generated from your new plugin!")));
};

export { Widget };